import {Component, signal, OnInit, OnDestroy} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {environment} from '../../../environments/environment';
import {Subscription} from 'rxjs';
import {v4 as uuid4} from 'uuid';
import {PusherService} from '../../services/pusher.service';

@Component({
  selector: 'app-create-test',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './create-test.component.html',
  styleUrls: ['./create-test.component.css'] // or .scss, if you prefer
})
export class CreateTestComponent implements OnInit, OnDestroy {
  domain:string = '';
  filter: string = 'test-run';
  isRunning = signal(false);
  isComplete = signal(false);
  isError = signal(false);
  errorMessage = signal('');
  progressValue = 0;
  requestId = '';
  testProgress = signal('');

  constructor(
    private http: HttpClient,
    private router: Router,
    private pusherService: PusherService
  ) {
  }

  ngOnInit() {
    this.requestId = uuid4();
  }

  ngOnDestroy() {
    this.pusherService.disconnect();
  }


  onSubmit() {

    this.pusherService.initSocket(this.requestId);

    this.pusherService.onTestCompleted( (data: any) => {

      console.log('Test completed:', data);
      if (data.testCompleted && data.domain === this.domain) {
        this.progressValue = 100;
        this.isRunning.set(false);
        this.isComplete.set(true);


        setTimeout(() => {
          this.router.navigate([`/test/${data.testId}`]);
        }, 5000);
      }
    });

    this.pusherService.onTestError((data: any) => {
      console.log('Test error:', data);
      this.isRunning.set(false);
      this.isComplete.set(false);

    });

    this.pusherService.connect(this.requestId);

    this.isRunning.set(true);

    this.pusherService.startTestRun(this.domain, this.filter);

    this.pusherService.onProgress((data: any) => {
      console.log('Progress:', data);
      this.testProgress.set(data.progressMessage);
    });

    this.pusherService.onDebugLog((data: any) => {
      console.log('DebugLog:', data);
    });
  }
}
